import React from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import ProjectStatus from '../components/Status'
import Banner from '../components/Banner'
import Seo from '../components/SEO/PageSeo'

const Status = () => {
  return (
    <Layout>
      <Seo />
      <Hero />

      <div className="text-center page-center">
        <h1>House construction with MCA in France: status</h1>.
        <p>
          At what stage is the construction of the house? Which step is next,
          which ones have already been completed?
        </p>
        <div className="underline"></div>
        <div className="posts-center">
          <article>
            <ProjectStatus />
          </article>
          <article>
            <Banner />
          </article>
        </div>
      </div>
    </Layout>
  )
}

export default Status
